import { AppData } from '../../../../types/appData'

export function handleSort(appData: AppData[], sortKey: 'name' | 'applicationCategory', sortOrder: 'ASC' | 'DESC') {
  const direction = sortOrder === 'ASC' ? 1 : -1

  return [...appData].sort((a, b) => {
    let valueA =
      sortKey === 'name' ? (a.name?.toLowerCase() ?? '') : (a.applicationCategory?.category?.toLowerCase() ?? '')
    let valueB =
      sortKey === 'name' ? (b.name?.toLowerCase() ?? '') : (b.applicationCategory?.category?.toLowerCase() ?? '')

    if (valueA < valueB) return -1 * direction
    if (valueA > valueB) return 1 * direction
    return 0
  })
}
